// extracted by mini-css-extract-plugin
export default {"menuTab":"pages-tabs_menuTab__RsqkX","pagesContainer":"pages-tabs_pagesContainer__4ZxE6"};